module.exports = __webpack_public_path__ + "img/icon_solicitud_consulta_compra_servicio.ba322dda.svg";